<template>
  <div :data-cy="`panelTraslado-${unico}`">
    <v-card>
      <v-card-text>
        {{ item.descripcion }}
        <v-form>
          <v-container>
            <v-layout wrap align-center justify-center>
              <v-flex xs12 sm5 v-if="item.direccion === 'I' || item.direccion === 'X'">
                <v-select
                  :items="pickerConfig.fechasLlegada"
                  label="Fecha de llegada del vuelo"
                  item-text="front"
                  item-value="back"
                  v-model="form.fechaLlegada"
                  v-validate="'required'"
                  name="fechaLlegada"
                  :error-messages="errors.collect('fechaLlegada')"
                  data-vv-as="fecha de llegada"
                  :disabled="seleccionado"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm5 v-if="item.direccion === 'I' || item.direccion === 'X'">
                <v-text-field
                  data-vv-as="número de vuelo"
                  label="Número de vuelo de llegada"
                  v-validate="'required'"
                  name="numeroLlegada"
                  v-model="form.nroVueloLlegada"
                  mask="AN####"
                  :disabled="seleccionado"
                  data-vv-delay="500"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 v-if="item.direccion === 'O' || item.direccion === 'X'">
                <v-select
                  :items="pickerConfig.fechasSalida"
                  label="Fecha de salida del vuelo"
                  item-text="front"
                  item-value="back"
                  v-model="form.fechaSalida"
                  v-validate="'required'"
                  name="fechaSalida"
                  :error-messages="errors.collect('fechaSalida')"
                  :disabled="seleccionado"
                  data-vv-as="fecha de salida"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm5 v-if="item.direccion === 'O' || item.direccion === 'X'">
                <v-text-field
                  data-vv-as="número de vuelo"
                  label="Número de vuelo de salida"
                  v-validate="'required'"
                  name="numeroSalida"
                  v-model="form.nroVueloSalida"
                  mask="AN####"
                  data-vv-delay="500"
                  :disabled="seleccionado"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn small color="primary" @click="confirmar" v-if="!seleccionado">Agregar</v-btn>
                  <v-btn small color="primary" @click="modificar" v-if="seleccionado">Modificar</v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog v-model="confirmTraslado" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirme la fecha del vuelo</v-card-title>

        <v-card-text>
          <p color="success" v-if="prepararFechaCompletaLlegada">
            El vuelo para este traslado llega el
            {{ prepararFechaCompletaLlegada | formatDate2Cliente }}
          </p>
          <p color="success" v-if="prepararFechaCompletaSalida">
            El vuelo para este traslado sale el
            {{ prepararFechaCompletaSalida | formatDate2Cliente }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="float-left" color="red" flat="flat" @click="descartar">
            Descartar
          </v-btn>

          <v-btn color="primary" flat="flat" @click="agregar">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment"
export default {
  name: "panelTraslado",
  props: ["item", "seleccionado", "hotel", "unico"],
  components: {},
  mounted() {},
  created() {
    this.createForm()
    this.armarPicker()
  },
  methods: {
    confirmar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.confirmTraslado = true
        }
      })
    },
    descartar() {
      this.form = { fechaLlegada: "", nroVuelo: "" }
      this.confirmTraslado = false
    },
    async agregar() {
      const itemCarrito = this.traslado2Carrito(
        this.unico,
        this.hotel.nombre,
        this.item.nombre,
        this.item.idTarifa,
        this.item.direccion,
        this.item.idProveedor,
        this.item.tarifas,
        this.item.tipo,
        this.form
      )
      const rs = await this.$store.dispatch("carrito/agregarTraslado", itemCarrito)
      this.$store.commit("carrito/setOpen", true)
      this.confirmTraslado = false
    },
    armarPicker() {
      let checkin = moment(this.hotel.checkin)
      let checkout = moment(this.hotel.checkout)
      checkin.subtract(1, "days")
      checkout.subtract(1, "days")
      for (var i = 0; i < 3; i++) {
        this.pickerConfig.fechasLlegada.push({
          front: checkin.format("DD-MM-YYYY"),
          back: checkin.format("YYYY-MM-DD")
        })
        this.pickerConfig.fechasSalida.push({
          front: checkout.format("DD-MM-YYYY"),
          back: checkout.format("YYYY-MM-DD")
        })
        checkin.add(1, "days")
        checkout.add(1, "days")
      }
    },
    prepararFecha(fecha) {
      let fechaHora = moment(fecha)
      return fechaHora
    },
    createForm() {
      if (this.item.direccion === "I" || this.item.direccion === "X") {
        this.form["fechaLlegada"] = ""
        this.form["nroVueloLlegada"] = null
      }
      if (this.item.direccion === "O" || this.item.direccion === "X") {
        this.form["fechaSalida"] = ""
        this.form["nroVueloSalida"] = null
      }
    },
    async modificar() {
      let toas = {
        tipo: "error",
        mensaje: "No se pudo eliminar el traslado a el hotel"
      }
      const rs = await this.$store.dispatch("carrito/borrarTraslado", {
        unico: this.unico,
        idTarifa: this.item["@attributes"].idTicket
      })
      if (rs) {
        toas = { tipo: "success", mensaje: "Traslado eliminado del carrito" }
      }
      this.createForm()
      this.$validator.reset()
      this.showToasted(toas.mensaje, toas.tipo)
    },
    traslado2Carrito(unico_hotel, nombreLugar, nombreTraslado, idTarifa, direccion, idProveedor, tarifas, tipo, form) {
      const traslado = {
        nombreTraslado: nombreTraslado,
        idTarifa: idTarifa,
        direccion: direccion,
        idProveedor: idProveedor,
        tarifas: tarifas,
        tipo: tipo,
        llegada: form.fechaLlegada,
        nroVueloLlegada: form.nroVueloLlegada,
        nroVueloSalida: form.nroVueloSalida,
        salida: form.fechaSalida
      }
      return {
        unico_hotel: unico_hotel,
        nombreLugar: nombreLugar,
        traslados: [traslado]
      }
    }
  },
  data() {
    return {
      form: {
        fechaLlegada: null,
        nroVueloLlegada: null,
        fechaSalida: null,
        nroVueloSalida: null
      },
      menu2: false,
      pickerConfig: { fechasLlegada: [], fechasSalida: [] },
      confirmTraslado: false
    }
  },
  computed: {
    prepararFechaCompletaLlegada() {
      if (this.form.fechaLlegada == undefined) {
        return null
      }
      const fechaHora = this.prepararFecha(this.form.fechaLlegada)
      return fechaHora
    },
    prepararFechaCompletaSalida() {
      if (this.form.fechaSalida == undefined) {
        return null
      }
      const fechaHora = this.prepararFecha(this.form.fechaSalida)
      return fechaHora
    }
  }
}
</script>
